module.exports = __webpack_public_path__ + "img/logo.c121e355.png";